import { forwardRef, Ref, type SVGProps } from 'react';

const SvgOcean = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <g fill="#033532">
      <path d="m17.166 4.728-.457.52c-1.217-1.317-3.328.644.148 3.034-4.739-1.847-7.003.937-8.9 4.637-.892 2.118-3.01 3.413-5.334 3.347-.392-1.036-1.001-2.668-1.13-3.06 4.23.229 5.505-4.559 6.797-7.645 1.02-2.483 3.037-4.716 5.994-3.884 0 0 2.393.5 2.882 3.05" />
      <path d="m1 17.314.959 2.186h15.788L19 16.44c-4.03-.606-4.418-3.392-2.922-3.884.867-.287 1.27.716 1.27.716l1.31-.756c-.027-.376-.451-1.36-.53-1.506-.282-.514-.66-.988-1.138-1.339-1.047-.767-2.636-.707-3.857-.426-2.07.476-3.338 2.887-4.365 4.87-.509.984-1.048 1.838-2.014 2.448-.773.486-1.671.75-2.575.867-.743.096-2.43-.042-3.175-.116z" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgOcean);
export default ForwardRef;
